import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getRemoteConfig, fetchAndActivate } from "firebase/remote-config";

let db = false;
let remoteConfig = false;

export const getDb = () => {
    if (!db) {
        const firebaseConfig = {
            apiKey: "AIzaSyDxwPU4SX6OW5RJpYBh3UFHNfNMM2wtpwA",
            authDomain: "whishlist-6b277.firebaseapp.com",
            projectId: "whishlist-6b277",
            storageBucket: "whishlist-6b277.appspot.com",
            messagingSenderId: "1082564181900",
            appId: "1:1082564181900:web:3a4dffe27040b6d6b320a9"
        };

        const app = initializeApp(firebaseConfig);
        db = getFirestore(app);
        remoteConfig = getRemoteConfig(app);

        remoteConfig.settings = {
            minimumFetchIntervalMillis: 3600000, // 1 hour
        };
        remoteConfig.defaultConfig = {
            warning_message: '',
            start_date: '',
            end_date: ''
        };

        fetchAndActivate(remoteConfig)
            .then(() => {
                console.log("Remote Config activé avec succès !");
            })
            .catch((error) => {
                console.error("Erreur lors de l'activation de Remote Config :", error);
            });
    }

    return db;
};

export const getRemoteConfigInstance = () => {
    if (!remoteConfig) {
        getDb();
    }
    return remoteConfig;
};
